import React from "react";
import { useGlobal } from "utils/globalState";
import { CookieSettingsLink } from "@jsainsburyplc/id-ui-common";
import { isHidingLinks } from "utils/hideLinks";

const FooterContent = () => {
  const [footerLinksList] = useGlobal("footer_links");
  const [footerLinks] = useGlobal("links");

  if (isHidingLinks()) {
    return <div className="ln-u-text-align-center" />;
  }

  if (footerLinksList?.length && footerLinks) {
    const links = footerLinksList.map((link, index) => (
      <span className="footer__span ln-u-align-items-center" key={index}>
        <a
          href={footerLinks[link].href}
          target="_blank"
          rel="noopener noreferrer"
          className="ln-o-bare-link footer__urls"
        >
          {footerLinks[link].text}
        </a>
        <span className="ln-u-push-sides-sm" />
      </span>
    ));
    return (
      <div className="ln-u-text-align-center">
        {links}
        <CookieSettingsLink />
      </div>
    );
  } else {
    return (
      <div className="ln-u-text-align-center">
        <CookieSettingsLink />
      </div>
    );
  }
};

export default FooterContent;
